import React, {FC} from 'react';
import multimedia from '../../assets/images/icon-page/city.png';


const CityIcon: FC<{ size?: number | string; alt?: string }> = ({size = 24, alt = 'City Icon'}) => {
    return (
        <img
            src={multimedia}
            alt={alt}
            style={{width: size, height: size, display: 'block'}}
        />
    );
};

export default CityIcon;
